import ErpConnections from './erp_connections';
import AdLogs from './ad_logs';

export default {
  ErpConnections,
  AdLogs,
};
